export class WhatsAppMessageDto {

    companyId: number;
	mobileNo: string[];
	templateId: string;
	parameters: string[];
}
